<!-- <h3>VALIDATION DE VOTRE PANIER</h3> -->
<div class="row">
    <div class="col-md-12">
        <div class="hd">
            <table width="100%">
                <tbody>
                    <tr>
                        <td class="nbr-a">
                            <span class="nbr">Nomber d"éléments: </span>
                            <span class="elementNbr">{{elementsNbr}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card">
            <table width="100%">
                <ng-container *ngFor="let el of order?.elements;let i=index">
                    <tr class="space"></tr>
                    <tr valign="top">
                        <td width="40px">
                            <img [src]="el.avatar|absolutePath:'products'"
                                class="w3-bar-item w3-circle w3-hide-small product-avatar">
                        </td>
                        <td class="pl-25 element">
                            <span>
                                <button class="moins cursor-pointer" (click)="decrQty(i,0)">
                                    <img src="assets/images/icons/moins.png" class="w3-bar-item w3-circle w3-hide-small">
                                </button>
                                <button class="moins">{{el.qty}}</button>
                                <button class="plus cursor-pointer" (click)="incrQty(i,0)">
                                    <img src="assets/images/icons/plus.png" class="w3-bar-item w3-circle w3-hide-small">
                                </button>
                            </span>
                            <span>{{el.name}} ( {{el.size.size}} {{el.priceWithSupp | number : '1.2-2'| helpycurrency}}
                                )</span><br>
                            <span class="supp d-block" *ngIf="el.removedCompositions?.length>0">
                                <span class="ingTitle d-block">sans :</span>
                                <ul>
                                    <li *ngFor="let comp of el.removedCompositions">
                                        <span>{{comp.text}} </span>
                                    </li>
                                </ul>
                            </span>
                            <span class="supp d-block" *ngIf="el.optionIngredients?.length>0">
                                <span class="ingTitle d-block">options :</span>
                                <ul>
                                    <li *ngFor="let opt of el.optionIngredients">
                                        <span>{{opt.text}} </span>
                                    </li>
                                </ul>
                            </span>
                            <span class="supp d-block" *ngIf="el.supplements?.length>0">
                                <span class="ingTitle d-block">supp :</span>
                                <ul>
                                    <li *ngFor="let supp of el.supplements">
                                        <span>{{supp.text}} ( {{supp.price  | helpycurrency}})</span>
                                    </li>
                                </ul>
                            </span>
                            <span class="supp d-block" *ngIf="el.comment">
                                <span class="ingTitle d-block">Commentaire :</span>
                                <span>{{el.comment}}</span>
                            </span>
                        </td>
                        <td class="text-right">
                            <span class="trash">
                                <i class="flaticon-garbage" (click)="removeElement(i,0)"></i>
                            </span>
                        </td>
                    </tr>
                    <tr class="tr-price">
                        <td colspan="2"></td>
                        <td class="text-right">
                            {{el.total | number : '1.2-2' | helpycurrency}}
                        </td>
                    </tr>
                </ng-container>
                <ng-container *ngFor="let menu of order?.menus;let i=index">
                    <tr class="space"></tr>
                    <tr valign="top">
                        <td width="40px">
                            <img [src]="menu.avatar|absolutePath:'menus'"
                                class="w3-bar-item w3-circle w3-hide-small product-avatar">
                        </td>
                        <td class="element-title element pl-25">
                            {{menu.title}}
                            <span
                                *ngIf="menu.offer==null">{{menu.priceWithSupp | number : '1.2-2' | helpycurrency}}</span>
                            <ul>
                                <li *ngFor="let el of menu?.elements;let i=index">
                                    {{el.name}} <span *ngIf="el.size.level>0">({{el.size.label}})</span> <br>
                                    <span class="supp d-block" *ngIf="el.removedCompositions?.length>0">
                                        <span class="ingTitle d-block">sans :</span>
                                        <ul>
                                            <li *ngFor="let comp of el.removedCompositions">
                                                <span>{{comp.text}} </span>
                                            </li>
                                        </ul>
                                    </span>
                                    <span class="supp d-block" *ngIf="el.optionIngredients?.length>0">
                                        <span class="ingTitle d-block">options :</span>
                                        <ul>
                                            <li *ngFor="let opt of el.optionIngredients">
                                                <span>{{opt.text}} </span>
                                            </li>
                                        </ul>
                                    </span>
                                    <span class="supp d-block" *ngIf="el.supplements?.length>0">
                                        <span class="ingTitle d-block">supp :</span>
                                        <ul>
                                            <li *ngFor="let supp of el.supplements">
                                                <span>{{supp.text}} ( {{supp.price| helpycurrency}} )</span>
                                            </li>
                                        </ul>
                                    </span>
                                </li>
                                <li *ngFor="let el of menu?.additionalOptions">
                                    {{el.name}} ({{el.size}} {{el.price| helpycurrency}} )
                                </li>
                            </ul>
                            <p>{{menu.commentaire}}</p>
                        </td>
                        <td width="60px" class="text-right">
                            <span class="trash">
                                <i class="flaticon-garbage cursor-pointer" (click)="removeElement(i,1)"></i>
                            </span>
                        </td>
                    </tr>
                    <tr class="tr-price">
                        <td colspan="2"></td>
                        <td class="text-right">
                            {{menu.total | number : '1.2-2'| helpycurrency}}
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="order.discount>0 || order.coupon>0 || order.fees>0">
                    <td colspan="2">Sous-total </td>
                    <td class="text-right">{{order.amount | number : '1.2-2'}}€</td>
                </tr>
                <tr *ngIf="order.discount>0">
                    <td colspan="2">Remise {{order.discount}}% </td>
                    <td class="text-right">{{order.discountValue | number : '1.2-2'}}€</td>
                </tr>
                <tr *ngIf="order.coupon>0">
                    <td colspan="2">
                        Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
                        <ng-container *ngIf="order.couponType==2">%</ng-container>
                    </td>
                    <td class="text-right">{{order.couponValue | number : '1.2-2'}}€</td>
                </tr>
                <tr *ngIf="order.fees>0">
                    <td colspan="2">{{order.feesLabel}} :</td>
                    <td class="text-right">{{order.fees | number : '1.2-2'}} €</td>
                </tr>
                <tr class="orderTotal">
                    <td colspan="2">TOTAL TTC</td>
                    <td class="text-right" width="100px">
                        {{order.total | number : '1.2-2'}} €
                    </td>
                </tr>
            </table>
        </div>
        <textarea placeholder="Ajouter Commentaire, sauce extra, sans oignons etc." name="comment"
            [(ngModel)]="order.comment" class="form-control" rows="4"></textarea>
        <table width="100%">
            <tr>
                <td>
                    <div class="continue">
                        <a routerLink="/carte">
                            Continuer ma commande
                        </a>
                    </div>
                </td>
                <td class="total text-right validate">
                    <button (click)="validate()" class="btn">
                        <i class="flaticon-tick"></i>
                        <span>
                            Confirmer la commande
                        </span>
                    </button>
                </td>
            </tr>
        </table>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy mr-10" aria-hidden="true"></i>
        </p>
        <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
        <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
        <button type="button" class="btn btn-default" (click)="confirm()">OUI</button>
        <button type="button" class="btn btn-template" (click)="decline()">NON</button>
    </div>
</ng-template>